import { Outlet } from "react-router";
import CompactFooter from "../components/footer/CompactFooter";
import style from "./Initial.module.css";
import Header from "../components/header/Header";
import Sidebar from "../components/sidebar/Sidebar";
import { useState } from "react";
import MenuConfiguracion from "../components/menuConfiguracion/MenuConfiguracion";
import { RoutePreloader } from "../components/RoutePreloader";
import Notificaciones from "../components/Notificaciones/Notificaciones";
import * as Sentry from '@sentry/react';
import ModuleCrashFallback from '../components/error-boundaries/ModuleCrashFallback';
import { useBuzonJudicialNotice } from "../hooks/useBuzonJudicialNotice.hook";

export const InitialLayout = () => {
    const [isOpenMobile, setIsOpenMobile] = useState(false);
    const [isMenuConfigOpen, setIsMenuConfigOpen] = useState(false);
    const [isOpenNotificaciones, setIsOpenNotificaciones] = useState(false);
    const [existenAlertas, setExistenAlertas] = useState(false);
    useBuzonJudicialNotice();

    const handleToggleConfigMenu = () => {
        setIsMenuConfigOpen(prevState => !prevState); // <-- Alterna entre true y false
        setIsOpenNotificaciones(false)
    };

    const handleCloseConfigMenu = () => {
        setIsMenuConfigOpen(false);
    };

    const handleOpenNotificaciones = () => {
        setIsOpenNotificaciones(prevState => !prevState);
    };

    return (
        <>
            <RoutePreloader />
            <div className={`${style.container} bg-[var(--color-blue-dark)]`}>
                <Header onToggleMenu={() => setIsOpenMobile(true)} onToggleConfigMenu={handleToggleConfigMenu} isConfigMenuOpen={isMenuConfigOpen} openNotificaciones={handleOpenNotificaciones} setExistenAlertas={setExistenAlertas} />
                <main className={`${style.ContainerMain} w-[100%] bg-[var(--color-blue-dark)] overflow-hidden`}> {/* rounded-b-[50px]  */}
                    <MenuConfiguracion MostrarMenuConfigOpen={isMenuConfigOpen} onClose={handleCloseConfigMenu} />
                    {
                        isOpenNotificaciones && (
                            <Notificaciones isOpenNotificaciones={isOpenNotificaciones} handleNotificaciones={handleOpenNotificaciones} existenAlertas={existenAlertas} />
                        )
                    }
                    <Sidebar MostrarMenuMobile={isOpenMobile} onToggleMenu={() => setIsOpenMobile(false)} idTour="SIDEBAR" />
                    <Sentry.ErrorBoundary fallback={ModuleCrashFallback}>
                        <Outlet />
                    </Sentry.ErrorBoundary>
                </main>
                <CompactFooter variant="minimal" />
            </div>
        </>
    );
}